module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/exception_frame-ff1110d7d4ed883217e3cfdcdf6f1c10.png";